import React from 'react';
import { CheckCheckIcon } from 'lucide-react';
import { images, testimonials } from '../data/landing';
export function TestimonialsSection() {
  return <section className="w-full bg-white py-20 lg:py-24" data-id="element-144" data-mp="20tjkfaian0bg">
      <div className="mx-auto max-w-content px-6" data-id="element-145" data-mp="1myzd3qnl019q">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[1fr_0.8fr] lg:gap-16" data-id="element-146" data-mp="1my7q3481vbv2">
          <div data-id="element-147" data-mp="1qzj9gs0bz0ut">
            <h2 className="max-w-xl font-display text-3xl font-bold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-148" data-mp="1d1unfguj1no6">
              Lo que nos escriben los profes.
            </h2>

            <ul className="mt-10 space-y-5" data-id="element-149" data-mp="1hyuv1w70yyhe">
              {testimonials.map(item => <li key={item.author} className="max-w-xl" data-id="element-150" data-mp="142zkcdms4tp3">
                  <div className="rounded-2xl rounded-tl-md bg-nature-soft px-5 py-4" data-id="element-151" data-mp="183t54y4xdsdr">
                    <p className="text-base leading-relaxed text-ink sm:text-lg" data-id="element-152" data-mp="2yenwy95jgk6b">
                      {item.quote}
                    </p>
                    <div className="mt-2 flex items-center justify-end gap-1 text-[11px] text-ink-muted" data-id="element-153" data-mp="32fzt6xix43nh">
                      <span data-id="element-154" data-mp="2uzrggvlt11hf">{item.time}</span>
                      <CheckCheckIcon className="h-3.5 w-3.5 text-nature-dark" aria-hidden="true" data-id="element-155" data-mp="2q3152lky2u2c" />
                    </div>
                  </div>
                  <p className="mt-2 pl-1 text-sm font-semibold text-ink" data-id="element-156" data-mp="2ztca6bgd79at">
                    {item.author}
                    <span className="ml-2 font-normal text-ink-muted" data-id="element-157" data-mp="2c3hxbtw1pkqk">
                      {item.role}
                    </span>
                  </p>
                </li>)}
            </ul>
          </div>

          <div className="grid grid-cols-2 gap-4 lg:grid-cols-1" data-id="element-158" data-mp="2m27d9h4dsv46">
            <figure className="overflow-hidden rounded-2xl" data-id="element-159" data-mp="2h0rs7p27eols">
              <img src={images.group2} alt="Grupo de running celebrando el final de un entrenamiento" className="h-44 w-full object-cover lg:h-56" width={1200} height={800} data-id="element-160" data-mp="1aniy5b6e9es" />
            </figure>
            <figure className="overflow-hidden rounded-2xl" data-id="element-161" data-mp="3h50q92xd7ze">
              <img src={images.group1} alt="Corredores entrenando juntos en el parque" className="h-44 w-full object-cover lg:h-56" width={1200} height={800} data-id="element-162" data-mp="8cah6sdk5ug3" />
            </figure>
          </div>
        </div>
      </div>
    </section>;
}